<div class="team-matches">
    <nb-card *ngFor="let game of games" class="mt-3">
        <nb-card-body>
            <div class="game-match-container">
                <div class="team">
                    <div class="team-info">
                        <img [src]="participantes['1'].url_avatar" [alt]="participantes['1'].nome" />
                        <p class="team-name">{{ participantes["1"].nome }}</p>
                    </div>
                    <div class="player-section">
                        <div class="player-avatar-container">
                            <div class="player-avatar" *ngFor="let participant of game.participantes['1']">
                                <img [src]="participant.url_avatar" [alt]="participant.nome_abreviado" />
                            </div>
                        </div>
                        <div class="player-name" *ngFor="let participant of game.participantes['1']">
                            {{ participant.nome_abreviado }}
                        </div>
                    </div>
                </div>
                <div class="player-scores">
                    <div
                        class="score-box"
                        *ngFor="let resultado of game.resultados"
                        [class.winner]="getWinner1(resultado)"
                    >
                        {{ resultado.resultado_1 }}
                    </div>
                </div>

                <div class="match-separator">
                    <div class="match-time" *ngIf="game.dt_jogo || game.hr_jogo">
                        <span>{{ game.dt_jogo }} - {{ game.hr_jogo?.slice(0, -3) }}</span>
                    </div>
                    <div class="match-separator-line"></div>
                </div>
                <div class="player-scores">
                    <div
                        class="score-box"
                        *ngFor="let resultado of game.resultados"
                        [class.winner]="getWinner2(resultado)"
                    >
                        {{ resultado.resultado_2 }}
                    </div>
                </div>

                <div class="team">
                    <div class="team-info team-info-2">
                        <img [src]="participantes['2'].url_avatar" [alt]="participantes['2'].nome" />
                        <p class="team-name">{{ participantes["2"].nome }}</p>
                    </div>
                    <div class="player-section">
                        <div class="player-avatar-container">
                            <div class="player-avatar" *ngFor="let participant of game.participantes['2']">
                                <img [src]="participant.url_avatar" [alt]="participant.nome_abreviado" />
                            </div>
                        </div>
                        <div class="player-name" *ngFor="let participant of game.participantes['2']">
                            {{ participant.nome_abreviado }}
                        </div>
                    </div>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</div>
